define(["require", "exports", "preact/jsx-runtime", "ojs/ojprogress-circle"], function (require, exports, jsx_runtime_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Spinner = void 0;
    const Spinner = () => {
        return ((0, jsx_runtime_1.jsx)("div", { className: "oj-flex-item oj-flex oj-sm-align-items-center oj-sm-justify-content-center", children: (0, jsx_runtime_1.jsx)("oj-progress-circle", { value: -1 }) }));
    };
    exports.Spinner = Spinner;
});
